export default "<div class=\"row\">\n    <div class=\"col-md-12 text-center\">\n        <h2> Verifying..... Please wait... </h2>\n    </div>\n</div>";